import { request } from './client';

export const apiGetCategories = () => request('/categories');

export const apiGetAllCategories = () => request('/categories/admin/all');

export const apiCreateCategory = (data) =>
  request('/categories', { method: 'POST', body: data });

export const apiUpdateCategory = (id, data) =>
  request(`/categories/${id}`, { method: 'PUT', body: data });

export const apiDeleteCategory = (id) =>
  request(`/categories/${id}`, { method: 'DELETE' });
